import Vue from 'vue'
import axios from 'axios';

Vue.prototype.$http = axios.create({baseURL: process.env.NODE_ENV !== 'production' ? process.env.VUE_APP_API_ENDPOINT_LOCAL : process.env.VUE_APP_API_ENDPOINT_PRODUCTION});

Vue.prototype.$http.interceptors.request.use(function (config) {
  config.headers['Authorization'] = `Bearer ${process.env.NODE_ENV !== 'production' ? process.env.VUE_APP_FITT_SECRET_KEY_LOCAL : process.env.VUE_APP_FITT_SECRET_KEY_PRODUCTION}`;

  return config;
}, function (error) {
  return Promise.reject(error);
});

Vue.prototype.$http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return Promise.reject(error);
});